module.exports = __webpack_public_path__ + "media/src/assets/Images/CarruselRight-d994e5cccc10b5a837012c953ebfba99.svg";